import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

import { prepareDefaultHeaders } from '../../api'

// Rooted at the connect server (not `/i/`) so a feature's public reads and `/i/` writes share one cache.
export const internalConnectApi = createApi({
  reducerPath: 'internalConnectApi',
  baseQuery: fetchBaseQuery({
    baseUrl: window.GR_API_URLS.API_URL_CONNECT_SERVER + '/',
    prepareHeaders: prepareDefaultHeaders,
  }),
  endpoints: () => ({}),
})
